export default "__VITE_ASSET__BGltsCsD__"